import { SidebarMenu } from './Sidebar'

export const NavigationLinks = {
    [SidebarMenu.Tenants]: '/manage-tenants',
    [SidebarMenu.EtpSync]: '/data-sync',
    [SidebarMenu.APIInsights]: '/api-insights',
    [SidebarMenu.IntegrationInsights]: '/integration-insights',
    [SidebarMenu.ServiceStatus]: '/service-status',
    [SidebarMenu.ErrorStatus]: '/error-insights',
    [SidebarMenu.DataPreview]: '/data-preview',
    [SidebarMenu.InvoiceDashboard]: '/invoice-dashboard',
    [SidebarMenu.CSDashboard]: '/cs-dashboard',
    [SidebarMenu.MarkPackagesPaid]: '/mark-packages-paid',
    [SidebarMenu.SupersetPresets]: '/superset-presets',
    [SidebarMenu.BreachReporting]: '/breach-reporting',
    [SidebarMenu.HelpVideos]: '/help-videos',
    [SidebarMenu.EmailValidation]: '/email-validation',
    [SidebarMenu.ConfigDocs]: '/config-docs',
    // [SidebarMenu.TenantAnalytics]: '/tenant-onboard-analytics',
}
